module.exports = __webpack_public_path__ + "static/media/COS_FOOTER_SANTE.a0ce9104.jpg";